import {
  ApplicationRef,
  ComponentRef,
  createComponent,
  Injectable,
  Type,
} from '@angular/core';

import { Router } from '@angular/router';
import { ShepherdService } from 'angular-shepherd';

@Injectable({
  providedIn: 'root',
})
export class WalkthroughService {
  private componentRef!: ComponentRef<any>;

  constructor(
    private appRef: ApplicationRef,
    private shepherdService: ShepherdService,
    private router: Router,
  ) {}

  attachComponent<T>(container: HTMLElement, component: Type<T>) {
    // Create the component reference
    this.componentRef = createComponent(component, {
      environmentInjector: this.appRef.injector,
    });
    // Attach the component to the Angular appRef for change detection
    this.appRef.attachView(this.componentRef.hostView);
    // Append the component's root HTML element to the step container
    container.appendChild((this.componentRef.hostView as any).rootNodes[0]);
  }

  detachComponent() {
    if (this.componentRef) {
      this.appRef.detachView(this.componentRef.hostView);
      this.componentRef.destroy();
    }
  }

  startTour() {
    this.shepherdService.defaultStepOptions = {
      scrollTo: true,
      cancelIcon: { enabled: true },
    };

    this.shepherdService.addSteps([
      {
        id: 'intro',
        text: 'Welcome to Sensika Home Page!',
        attachTo: { element: '#welcome', on: 'bottom' },
        buttons: [
          {
            text: 'Cancel',
            action: () => {
              this.shepherdService.complete();
            },
          },
          {
            text: 'Next',
            action: () => {
              this.shepherdService.next();
            },
          },
        ],
      },
      {
        id: 'workspace-step',
        text: 'Now let’s go to the Workspace Page',
        attachTo: { element: '', on: 'right' },
        buttons: [
          {
            text: 'Back',
            action: () => {
              this.shepherdService.back();
            },
          },
          {
            text: 'Next',
            action: () => {
              this.router
                .navigate(['/workspace/3be6b9103b9cd9db7ec96b2cc1616fda'])
                .then(() => {
                  // Wait for navigation to complete before proceeding to the next step
                  setTimeout(() => this.shepherdService.next(), 500);
                });
            },
          },
        ],
      },
      {
        id: 'workspace-creation-step',
        text: 'Here you can see the objects in the workspace.',
        attachTo: { element: '#about', on: 'top' },
        buttons: [
          {
            text: 'Back',
            action: () => {
              this.shepherdService.back();
            },
          },
          {
            text: 'Next',
            action: () => {
              this.shepherdService.next();
            },
          },
        ],
      },
      {
        id: 'feed-step',
        text: 'Now let’s go to the feed page.',
        buttons: [
          {
            text: 'Back',
            action: () => {
              this.shepherdService.back();
            },
          },
          {
            text: 'Next',
            action: () => {
              this.router
                .navigate([
                  '/workspace/3be6b9103b9cd9db7ec96b2cc1616fda/feed/bfa7f870983f01ac0a8fe825c4e112b5',
                ])
                .then(() => {
                  // Wait for navigation to complete before proceeding to the next step
                  setTimeout(() => this.shepherdService.next(), 500);
                });
            },
          },
        ],
      },
      {
        id: 'feed-posts-page',
        text: 'Here you can see the posts in the feed.',
        attachTo: { element: '#posts', on: 'right' },
        buttons: [
          {
            text: 'Back',
            action: () => {
              this.shepherdService.back();
            },
          },
          {
            text: 'Next',
            action: () => {
              this.shepherdService.next();
            },
          },
        ],
      },
      {
        id: 'workspace-creation-step',
        text: 'Here you can see the widgets in the feed.',
        attachTo: { element: '#widgets', on: 'left' },
        buttons: [
          {
            text: 'Finish',
            action: () => {
              this.router.navigate(['/analytics/home']);
              this.shepherdService.complete();
            },
          },
        ],
      },
    ]);

    this.shepherdService.start();
  }
}
